import { Address } from "viem";
import { equalIgnoreCase } from "@unlockdfinance/verislabs-web3/utils";
import { app } from "app.config";

export default function getNameFromCollectionAddress(
  _address: Address
): string {
  const collection = app.COLLECTIONS.find(({ address }) =>
    equalIgnoreCase(_address, address)
  );

  if (!collection) throw new Error("Collection not supported");

  return collection.name;
}
